import _ from 'lodash';
import React from 'react';
import {submit, isSubmitting, formValueSelector} from 'redux-form';

import {MODALS} from 'ducks/bookings';

import Button from 'components/Button';
import {default as Modal, withModal} from 'components/Modal';
import {BookingOption} from 'components/Fields/BookingSelectField/components';

import './styles.css';

class ConfirmChargeModal extends React.Component<any> {
  onSubmit = () => {
    this.props.closeModal();

    this.props.submit('createOneOffChargeInvoiceAndPayment');
  };

  render() {
    const {
      booking,
      data: {
        form: {
          submitting,
          oneOffChargeReason,
          description,
          paymentMethod,
          createPayment,
          amount
        }
      }
    } = this.props;

    let paymentMethodLabel = '-';
    if (createPayment) {
      paymentMethodLabel = _.get(paymentMethod, 'label', '-');
    }

    const sections = [
      {heading: 'Charge type', value: _.get(oneOffChargeReason, 'label', '-')},
      {heading: 'Description', value: description || '-'},
      {heading: 'Payment methods', value: paymentMethodLabel},
      {heading: 'Total amount', value: `£${amount || ' -'}`},
      {heading: 'For booking', value: <BookingOption object={booking} />}
    ];

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.EXTRA_SMALL}
        className="ConfirmChargeModal">
        <Modal.Header heading="Confirm charge" />
        <Modal.Body>
          <div className="ConfirmChargeModal__message">
            You will create a charge for
          </div>
          {sections.map(section => (
            <div key={section.heading} className="ConfirmChargeModal__section">
              <div className="ConfirmChargeModal__section__label colab-bold">
                {section.heading}
              </div>
              <div className="ConfirmChargeModal__section__value">
                {section.value}
              </div>
            </div>
          ))}
          <div className="ConfirmChargeModal__question">
            Are you sure you want to add this charge?
          </div>
        </Modal.Body>
        <Modal.Footer className="colab-row-space-between">
          <Button white onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button
            onClick={this.onSubmit}
            blue={!submitting}
            isLoading={submitting}
            disabled={submitting}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const formSelector = formValueSelector('createOneOffChargeInvoiceAndPayment');

const mapStateToModalData = state => ({
  form: {
    submitting: isSubmitting('createOneOffChargeInvoiceAndPayment')(state),
    oneOffChargeReason: formSelector(state, 'oneOffChargeReason'),
    description: formSelector(state, 'description'),
    paymentMethod: formSelector(state, 'paymentMethod'),
    createPayment: formSelector(state, 'createPayment'),
    amount: formSelector(state, 'amount')
  }
});

const mapDispatchToProps = {
  submit
};

export default withModal(
  MODALS.CONFIRM_CHARGE,
  mapStateToModalData,
  mapDispatchToProps
)(ConfirmChargeModal);
